const getUrlParams = param => {
	const params = new URLSearchParams(window.location.search);
	return params.get(param) ?? null;
};

const getUrlWithoutQuery = query => {
	try {
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.delete(query);
		return urlParams.toString();
	} catch (e) {
		return null;
	}
};

const getUrlWithoutQueries = queries => {
	try {
		const urlParams = new URLSearchParams(window.location.search);
		queries.forEach(query => urlParams.delete(query));
		return urlParams.toString();
	} catch {
		return null;
	}
};

const createUrlParameters = data =>
	Object.keys(data)
		.map(key => {
			const encodedKey = encodeURIComponent(key);
			const encodedDataKey = encodeURIComponent(data[key]);
			return `${encodedKey}=${encodedDataKey}`;
		})
		.join('&');

export { getUrlParams, getUrlWithoutQuery, getUrlWithoutQueries, createUrlParameters };
